import {
  VENDOR_EMPLOYEE_WELFARE_FUND_FETCHING,
  VENDOR_EMPLOYEE_WELFARE_FUND_FAILED,
  VENDOR_EMPLOYEE_WELFARE_FUND_SUCCESS,
} from "../actions/types";

const initialState = {
  result: [],
  isFetching: true,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case VENDOR_EMPLOYEE_WELFARE_FUND_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case VENDOR_EMPLOYEE_WELFARE_FUND_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };
    case VENDOR_EMPLOYEE_WELFARE_FUND_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
